@if (isOpened) {
  <div [@fadeIn]="isOpened" class="overlay" (click)="closeActions.emit()"></div>
}

<div class="actions">
  @for (action of actions; track action) {
    <i
      [class]="action.icon"
      tooltipPosition="top"
      [pTooltip]="action.tooltip | translate"
      tooltipStyleClass="rotary-dial-tooltip"
      (click)="handleActionClick(action.action)">
    </i>
  }
</div>
